var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.026,
    height: 18,
    viewBox: "0 0 18.026 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_103510_text_document_accept_icon",
    "data-name": "103510_text_document_accept_icon",
    transform: "translate(0.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 18,
    height: 18,
    transform: "translate(-0.026 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "document_x5F_text_x5F_accept"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M13.5,7.908V3.141L10.358,0H0V18H13.5v-.033a5.06,5.06,0,0,0,0-10.059ZM10.124,1.357l2.018,2.018H10.124Zm-9,15.518V1.124H9V4.5h3.375V7.908A5.038,5.038,0,0,0,9.758,9H2.25v1.125H8.728a5.036,5.036,0,0,0-.559,1.125H2.25v1.125H7.908a5.027,5.027,0,0,0,1.851,4.5Zm11.813-.066a3.872,3.872,0,1,1,3.872-3.872A3.88,3.88,0,0,1,12.938,16.809ZM11.25,6.75h-9V7.875h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M18,21.25l1.125-1.125L20.25,21.25,22.5,19l1.125,1.125L20.25,23.5Z",
    transform: "translate(-7.875 -8.313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAccept);
export default __webpack_public_path__ + "static/media/document_accept.7644d143dc50b2dea98697e3c0b45df7.svg";
export { ForwardRef as ReactComponent };